import { ENTERPRISE_VISIBLE_APPLICATION_STATUSES } from "@kansai-ai-hub/types";

const ENTERPRISE_VISIBLE_SET = new Set<string>(ENTERPRISE_VISIBLE_APPLICATION_STATUSES);

/**
 * 企業画面で AUDIT 系 status (PENDING_AUDIT / AUDIT_BLOCKED) を弾くフィルタ。
 *
 * URL 直叩き `?statuses=PENDING_AUDIT,NEW` のような混入経路から、
 * ENTERPRISE_VISIBLE 4 種だけを抽出する。
 *
 * - 入力: カンマ区切り文字列 (zod schema `applications.statuses` のフォーマット) または undefined
 * - 出力: visible のみを残したカンマ区切り、ヒット 0 件なら undefined
 *
 * 利用箇所:
 * - `routes/_authenticated/enterprise/applications/index.tsx` の `loaderDeps` で API 入力を sanitize
 * - `features/enterprise/applications-page.tsx` の FilterMultiSelect の value を sanitize して UI 整合
 */
export function sanitizeEnterpriseStatuses(
  value: string | undefined,
): string | undefined {
  if (!value) return undefined;
  const visible = value
    .split(",")
    .map((s) => s.trim())
    .filter((s) => ENTERPRISE_VISIBLE_SET.has(s));
  return visible.length > 0 ? visible.join(",") : undefined;
}

/** 配列形式 (FilterMultiSelect の value 用) で sanitize したい場合のヘルパー。 */
export function sanitizeEnterpriseStatusesArray(
  values: ReadonlyArray<string>,
): string[] {
  return values.filter((s) => ENTERPRISE_VISIBLE_SET.has(s));
}
